import {
    Box,
    Container,
    Paper,
    Stack,
    Typography
} from "@mui/material";
import TabIcon from "@mui/icons-material/Tab";

export default function AlreadyOpen() {
    return (
        <Box className="h-full max-h-full justify-center flex items-center"
            bgcolor={(theme) => theme.palette.grey[50]}
        >
            <Container maxWidth="md">
                <Paper className="!items-center !p-4 !rounded"
                    elevation={6}
                >
                    <Stack spacing={3} alignItems="center">
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            width={100}
                            height={100}
                            borderRadius="50%"
                        >
                            <TabIcon className="!text-4xl !text-[#018089]" />
                        </Box>

                        <Typography variant="h5" fontWeight={600}>
                            Dashboard/Upload page is already open
                        </Typography>


                        <Typography variant="body1" color="text.secondary">
                            This page can only be active in one browser tab at a time to prevent conflicts.
                            {" "}
                            <Typography component="span" fontWeight={600} color="text.primary">
                                Please switch to the existing tab.
                            </Typography>
                        </Typography>

                    </Stack>
                </Paper>
            </Container>
        </Box>
    );
}
